export default "__VITE_ASSET__ba6fb80d__"